import { render, staticRenderFns } from "./syllabusAndBooks.vue?vue&type=template&id=b57a11b2&scoped=true&"
import script from "./syllabusAndBooks.vue?vue&type=script&lang=js&"
export * from "./syllabusAndBooks.vue?vue&type=script&lang=js&"
import style0 from "./syllabusAndBooks.vue?vue&type=style&index=0&id=b57a11b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57a11b2",
  null
  
)

export default component.exports